import { Column, Grid, Label, Link, Row, useAlignments, useScreen } from 'metrix-common3';
import React from 'react';

const PolicyListItem = (props) => {
    const alignments = useAlignments();
    const screen = useScreen();

    const getDescription = () => {
        let description = null;

        if (props.policy.policyDescription) {
            description = props.policy.policyDescription;
        }

        if (props.policy.insuredName) {
            description = `${props.policy.insuredName} - ${description}`;
        }

        return description;
    };

    const getAssignedTo = () => {
        let assignedTo = null;

        if (props.policy.assignedTo) {
            if (props.policy.assignedTo) {
                assignedTo = props.policy.assignedTo;
            }
        }

        return assignedTo;
    };

    const profileLink = `${props.context.configuration.policyWeb}/profile?entity=${props.policy.policyTransactionGuid}`;

    return (
        <Grid>
            <Row>
                {!screen?.isMobile && (
                    <Column md={screen?.isTablet ? 2 : 1}>
                        <Link
                            text={props.policy.submissionReferenceNumber}
                            textAlign={alignments.left}
                            href={profileLink}
                        />
                    </Column>
                )}
                {screen?.isDesktop && (
                    <Column md={1}>
                        <Label text={props.policy.policyNumber} textAlign={alignments.left} />
                    </Column>
                )}
                {screen?.isMobile && (
                    <Column xs={5}>
                        <Label text={getDescription()} textAlign={alignments.left} />
                        <Link
                            text={props.policy.submissionReferenceNumber}
                            href={profileLink}
                            textAlign={alignments.left}
                        />
                    </Column>
                )}
                {!screen?.isMobile && (
                    <React.Fragment>
                        <Column md={screen?.isTablet ? 2 : 1}>
                            <Label text={props.policy.insuredName} textAlign={alignments.left} />
                        </Column>
                        <Column md={2}>
                            <Label text={props.policy.doingBusinessAs} textAlign={alignments.left} />
                        </Column>
                    </React.Fragment>
                )}
                {!screen?.isMobile && (
                    <React.Fragment>
                        <Column md={screen?.isTablet ? 4 : 2}>
                            <Label text={props.policy.productDescription} textAlign={alignments.left} />
                        </Column>
                        <Column md={1}>
                            <Label text={props.policy.createdOnDate} textAlign={alignments.left} />
                        </Column>
                    </React.Fragment>
                )}
                {screen?.isDesktop && (
                    <Column md={2} lg={2}>
                        <Label text={getAssignedTo()} textAlign={alignments.left} />
                    </Column>
                )}
                <Column xs={2} md={1} lg={1}>
                    <Label text={props.policy.transactionType} textAlign={alignments.left} />
                </Column>
            </Row>
        </Grid>
    );
};

export default PolicyListItem;
